import { Trans } from '@lingui/react/macro';
import { noddiAsync, URLKeys } from 'noddi-async';
import { brandLabels } from 'noddi-types';
import { cn } from 'noddi-ui-common';
import { NoddiBasicCard, NoddiDummyButton } from 'noddi-ui-web';
import { customerRoutes } from 'noddi-util';
import { tracking, useAuthContext } from 'noddi-web';
import { useCurrentBrand } from '../../stores/BrandStore/brandStore';
import { formatReferralProgramDiscountLabel } from '../../utils/referralProgramDisplay';

type Props = {
  className?: string;
};

export const InviteFriendsTeaser = ({ className }: Props) => {
  const { currentUserGroupId } = useAuthContext();
  const { currentBrand } = useCurrentBrand();
  const brandLabel = brandLabels[currentBrand];

  const {
    data: referral,
    isPending,
    error
  } = noddiAsync.useGet({
    type: URLKeys.getReferrals,
    input: { userGroupId: currentUserGroupId!, brandDomain: currentBrand },
    queryConfig: { enabled: currentUserGroupId != null }
  });

  if (currentUserGroupId == null || isPending || error != null) {
    return null;
  }

  if (referral.referralCode == null || referral.referralCode === '') {
    return null;
  }

  const currentRewardLabel = formatReferralProgramDiscountLabel(referral.currentReward ?? []);

  return (
    <NoddiBasicCard
      onClick={() => {
        tracking.track('referralPressedAfterBooking');
      }}
      to={customerRoutes.myReferrals.getPath()}
      variant='secondary'
      className={cn('flex flex-col gap-4', className)}
    >
      <p className='text-xl font-semibold text-primary'>
        <Trans>Enjoying {brandLabel} so far?</Trans>
      </p>

      <p className='text-balance'>
        {currentRewardLabel ? (
          <Trans>Invite a friend and earn {currentRewardLabel} when they pay for their first booking</Trans>
        ) : (
          <Trans>Invite a friend and earn a reward when they pay for their first booking</Trans>
        )}
      </p>

      <div className='flex items-end justify-between'>
        <img className='-mb-2 w-20' src='/assets/svgs/CarryingTires.svg' alt='' />
        <NoddiDummyButton variant='outline' startIcon='SquareArrowOutUpRight' size='small'>
          <Trans>Invite a friend</Trans>
        </NoddiDummyButton>
      </div>
    </NoddiBasicCard>
  );
};
